import React from "react";
import "./CSS/SamajikUpakaran.css";
import img1 from "./IMAGES/1001088644 1.png";
import img2 from "./IMAGES/1001088670 1.png";
import img3 from "./IMAGES/Rectangle 3.png";
import img4 from "./IMAGES/1001088646 1.png";
import img5 from "./IMAGES/1001088658 1.png";
import img6 from "./IMAGES/Rectangle 6.png";
import img7 from "./IMAGES/blood.jpg";
import history from "./IMAGES/historial.jpg"

const initiatives = [
  {
    img: img1,
    title: "डॉल्बी मुक्त मिरवणूक ",
    desc: "२०१० "
  },
  {
    img: img2,
    title: "जलयुक्त शिवार ",
    desc: "कलेक्टर अश्विन मुद्गल भेट"
  },
  {
    img: img3,
    title: "गडकोट मोहीम ",
    desc: "आपल्या इतिहासाचे स्मरण आणि प्रेरणा" 
  },
  {
    img: img4,
    title: "श्री स्वामी समर्थ प्रकट दिन सोहळा",
    desc: "भक्ती साधना आणि समर्पणाचा उत्सव"
  },
  {
    img: img5,
    title: "चित्रकला स्पर्धा ",
    desc: "सामाजिक प्रबोधन आणि सांस्कृतिक वारसा "
  },
  {
    img: img6,
    title: "आरोग्य तपासणी शिबीर ",
    desc: "सामाजिक प्रबोधन आणि सांस्कृतिक वारसा "
  },
    {
    img: img7,
    title: "मोफत रक्तदान शिबिर",
    desc: "आरोग्य तपासणी व नेत्रतपासणी शिबिर योग व ध्यान वर्ग – मानसिक व शारीरिक तंदुरुस्ती साठी"
  },
   {
    img: img7,
    title: "शैक्षणिक उपक्रम",
    desc: "गरीब व होतकरू विद्यार्थ्यांना शालेय साहित्य वाटप करिअर मार्गदर्शन शिबिर स्पर्धा परीक्षा मार्गदर्शन वर्ग"
  },
   {
    img: img7,
    title: " पर्यावरणपूरक उपक्रम",
    desc: "वृक्षारोपण मोहीम प्लास्टिक मुक्त गाव / परिसर मोहीम स्वच्छता अभियान – आपला परिसर स्वच्छ, निरोगी"
  },  {
    img: history,
    title: " समाजजागृती उपक्रम",
    desc: "ऐतिहासिक गड-किल्ल्यांवर स्वच्छता मोहीम"
  },
   {
    img: img7,
    title: " आपत्ती व्यवस्थापन व मदतकार्य",
    desc: "पूरग्रस्तांना मदत व साहित्य संकलन गरजूंना कपडे, अन्नधान्य वाटप"
  }


];

const SocialInitiatives = () => {
  return (
    <section className="initiatives-section">
      <h2 className="section-title">सामाजिक उपक्रम</h2>
      <p className="section-desc">
      भैरवनाथ क्रीडा मंडळ समाजहितासाठी विविध उपक्रम सातत्याने राबवत आहे. सामाजिक ऐक्य, आरोग्य जनजागृती, शिक्षण प्रबोधन, स्वच्छता मोहिमा, रक्तदान शिबिरे, पर्यावरण संवर्धन व गरजूंसाठी मदतकार्य या माध्यमातून मंडळाने समाजसेवेला प्राधान्य दिले आहे. या उपक्रमांतून एक संवेदनशील, जबाबदार आणि प्रगतिशील समाज निर्माण करण्यासाठी मंडळाची बांधिलकी दिसून येते.
      </p>
      <div className="initiatives-grid">
        {initiatives.map((item, index) => (
          <div className="initiative-card" key={index}>
            <img src={item.img} alt={item.title} />
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SocialInitiatives;
